import Content from './Content/Content'
import Options from './Options/Options'


const PrivacyPolicyContainer = () => {
    return (
        <>
            <Content />
            <Options />
        </>
    )
}

export default PrivacyPolicyContainer